import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { TimeRecordingEntryP40Model } from '@evorait/pace-core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-add-time-recording-entry',
    templateUrl: './add-time-recording-entry-p40.component.html',
    styleUrls: ['./add-time-recording-entry-p40.component.scss'],
})
export class AddTimeRecordingEntryP40Component implements OnInit {
    @Input()
    public entry: TimeRecordingEntryP40Model;

    @Input()
    public edit: boolean;

    @Output()
    public entryChange = new EventEmitter<TimeRecordingEntryP40Model>();

    public addEntryForm: FormGroup;
    public addEntryFormChildren: FormArray;
    public title = '';
    public constructor(
        private readonly formBuilder: FormBuilder,
        private translate: TranslateService,
        public readonly modalInstance: BsModalRef,
    ) {}

    public ngOnInit(): void {
        this.title = this.edit
            ? <string>this.translate.instant('CONFIRMATION_TIME_RECORDING_P40_EDIT_ENTRY_TITLE')
            : <string>this.translate.instant('CONFIRMATION_TIME_RECORDING_P40_ADD_ENTRY_TITLE');

        this.addEntryFormChildren = this.formBuilder.array([]);
        this.addEntryForm = this.formBuilder.group({
            children: this.addEntryFormChildren,
        });
    }

    public saveEntry(): void {
        this.modalInstance.hide();
        this.entryChange.emit(this.entry);
    }
}
